import styled from "styled-components";

import { motion } from "framer-motion";
import animations from "../../../../utils/animation";

export const Container = styled.div`
  width: 55vw;
  max-height: 95vh;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 5px;

  padding: 44px;

  @media (max-width: 1024px) {
    margin-top: 30px;
    width: 95vw;
    max-height: 100vh;
    padding-bottom: 100px;
  }
`;

export const ButtonBack = styled.button`
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: transparent;
`;

export const LabelBack = styled.p`
  margin-left: 10px;
  color: #707070;
`;

export const IconBack = styled.img`
  width: 20px;
  height: 20px;
`;

export const ListPatient = styled(motion.div).attrs(animations)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  overflow: auto;
  @media (max-width: 1024px) {
    flex-direction: column;
    height: 100%;
  }
`;

export const PatientSection = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0 10px 5px;
  padding: 0 0 5px;
  border-bottom: 1px solid #ddd;
  width: 100%;
  min-width: 300px;

  @media (max-width: 1024px) {
    width: 100%;
    min-width: 100%;
    margin: 10px 0;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
  }

  &:hover {
    transition: 0.3s;
    opacity: 0.7;
  }
`;

export const ButtoAddPatient = styled.button`
  min-width: 46px;
  width: 46px;
  height: 46px;
  margin: 5px;

  border-radius: 46px;
  background: #2196f3;
`;

export const ImgButtonAddPatient = styled.img`
  width: 22px;
  height: 22px;
`;

export const ImagePatient = styled.img`
  min-width: 46px;
  width: 46px;
  height: 46px;
  border-radius: 46px;
  margin: 5px;
`;

export const NamePatient = styled.div`
  color: #000;
  font-size: 12px;
  margin: 5px;

  @media (max-width: 1024px) {
    font-size: 14px;
    font-weight: bold;
    margin: 5px;
  }
`;

export const DivArrow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  padding-top: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #00000A;
`;

export const SubTitle = styled.div`
  padding-top: 8px;
  font-size: 14px;
  color: #707070;
`;

export const Inputs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin: 25px 0px 0px 0px;

  @media (max-width: 1024px) {
    margin: 0px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
`;

export const Label = styled.label`
  margin-top: 8px;

  input {
    margin-right: 10px;
  }
`;

export const DivInput = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : "285px")};
  height: 60px;

  label {
    width: 100%;
    text-align: left;
    font-size: 10px;
    height: 12px;
  }

  @media (max-width: 1024px) {
    width: 350px;
  }

  @media (max-width: 425px) {
    width: 270px;
  }
`;

export const ErrorMessage = styled.p`
  color: red;
  width: 100%;
  padding: 5px 0;
  font-size: 10px;
`;

export const Select = styled.select`
  border: 0;
  border-bottom: 1px solid #000;
  background-color: transparent;
  width: 100%;
  padding: 7px 0;
`;